import { ChevronRight } from "lucide-react";
import { Skeleton } from "../../../components/ui/skeleton";
import { cn } from "../../../utils/tailwindUtils";

// The card every rep-dashboard section sits in: title row with an optional
// "View all" link, a skeleton while loading, and the section body.
const Panel = ({ title, icon: Icon, action, onAction, loading, className, children, badge }) => (
    <section className={cn(
        "bg-white dark:bg-gray-800 rounded-2xl border border-gray-200/80 dark:border-gray-700",
        "shadow-sm p-4 flex flex-col min-w-0",
        className,
    )}>
        <header className="flex items-center justify-between gap-2 mb-3">
            <div className="flex items-center gap-2 min-w-0">
                {Icon && (
                    <span className="p-1.5 rounded-lg bg-brand-50 text-brand-600 dark:bg-brand-900/30 dark:text-brand-300">
                        <Icon className="h-4 w-4" />
                    </span>
                )}
                <h2 className="text-sm font-semibold text-gray-900 dark:text-white truncate">{title}</h2>
                {badge}
            </div>
            {action && (
                <button
                    type="button"
                    onClick={onAction}
                    className="flex items-center gap-0.5 text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-300 whitespace-nowrap"
                >
                    {action} <ChevronRight className="h-3.5 w-3.5" />
                </button>
            )}
        </header>
        {loading ? (
            <div className="space-y-2">
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
                <Skeleton className="h-4 w-2/3" />
            </div>
        ) : children}
    </section>
);

// Shown in place of a list with nothing in it. Says what to do instead.
export const Empty = ({ icon: Icon, title, hint }) => (
    <div className="flex flex-col items-center justify-center text-center py-6 px-2">
        {Icon && <Icon className="h-8 w-8 text-gray-300 dark:text-gray-600 mb-2" />}
        <p className="text-sm font-medium text-gray-700 dark:text-gray-300">{title}</p>
        {hint && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{hint}</p>}
    </div>
);

export default Panel;
